export default __webpack_public_path__ + "static/gnosis-35a709e5cbaf2078815a73b7402f66d3.svg";